export default __webpack_public_path__ + "static/media/move.269ff7cd.svg";